import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var LinkedItemsHelper =
/*#__PURE__*/
function () {
  function LinkedItemsHelper() {
    _classCallCheck(this, LinkedItemsHelper);
  }

  _createClass(LinkedItemsHelper, [{
    key: "convertLinkedItemsToArray",
    value: function convertLinkedItemsToArray(linkedItems) {
      var linkedItemsArray = [];

      for (var _i = 0, _Object$keys = Object.keys(linkedItems); _i < _Object$keys.length; _i++) {
        var linkedItemKey = _Object$keys[_i];
        linkedItemsArray.push(linkedItems[linkedItemKey]);
      }

      return linkedItemsArray;
    }
  }]);

  return LinkedItemsHelper;
}();
export var linkedItemsHelper = new LinkedItemsHelper();